import palette from '../theme/palette';

const cssVar = value => {
  const match = /var\((--[^)]+)\)/.exec(value);
  const name = match ? match[1] : value;
  return typeof window !== 'undefined'
    ? getComputedStyle(document.documentElement).getPropertyValue(name).trim() || name
    : name;
};

export const ACTION_ICON_COLORS = {
  edit: cssVar(palette.actionIcon.edit),
  delete: cssVar(palette.actionIcon.delete),
  share: cssVar(palette.actionIcon.share),
  see: cssVar(palette.actionIcon.see),
};

export const ACTION_ICON_COLORS_ARRAY = Object.values(ACTION_ICON_COLORS);
export const ACTION_ICON_COLORS_MAP = Object.entries(ACTION_ICON_COLORS).reduce((acc, [key, value]) => {
  acc[key] = value;
  return acc;
}, {});
export const ACTION_ICON_COLORS_KEYS = Object.keys(ACTION_ICON_COLORS);
